import { ReferenceData } from './reference-data.model';
import { Color } from './embedded/color.model';

export class MaterialType extends ReferenceData {

  materialGroup: string;
  subgroup: string;
  color: Color;

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.materialGroup = data.materialGroup;
    this.subgroup = data.subgroup;

    if (data.color) {
      this.color = new Color(data.color);
    }
  }
}
